// extracted by mini-css-extract-plugin
export default {"charts":"styles_charts__Hj4sc","legend":"styles_legend__iK+Yy","chart-container":"styles_chart-container__Wismp"};